export const TRANSACTIONS = 'Transactions';

export const TRANSACTIONS_PAGES = {
  TABLE: 'table',
  SETTING: 'setting',
};

// tooltip names
export const BACK = 'Back to Menu';

export const TRANSACTION_BANK_FIELDS = [
  { id: 'description', label: 'Description', align: 'left' },
  { id: 'amount', label: 'Amount', align: 'left' },
  { id: 'dateTime', label: 'Date', align: 'left' },
  {},
];

export const TRANSACTION_EXPENSE_FIELDS = [
  { id: 'description', label: 'Description', align: 'left' },
  { id: 'amount', label: 'Amount', align: 'left' },
  { id: 'dateTime', label: 'Date', align: 'left' },
  {},
];

export const expenses = [
  'Match',
  'High Roller Match',
  'Bonus',
  'Employees',
  "Sam's",
  'Food Expense',
  'Maintenance/Upgrades',
  'Miscellaneous',
  'Drawings',
];

export const DESCRIPTION_INFO = {
  'OPENING BANK': 'Starting shift cash. / Efectivo inicial del turno.',
  'ADD BANK': 'Add cash to bank. / Agregar efectivo al banco.',
  'MANAGER LOAN TO BANK':
    'Loan added to operations. / Préstamo agregado a operación.',
  PULLS: 'Money pulled out from machines. / Dinero sacado de las máquinas.',
  ZELLE: 'Zelle payment (verify name). / Pago por Zelle (verificar nombre).',
  'TRANSFER MONEY TO EMPLOYEE':
    'Cash given to another employee. / Dinero dado a otro empleado.',
  'EMPLOYEE PAYROLL': 'Employee payment. / Pago de empleado.',
  'SECURITY PAYROLL': 'Security payment. / Pago de seguridad.',
  'CUSTOMER LOANS':
    'Loan to customer (verify name). / Préstamo a cliente (verificar nombre).',
  'CUSTOMER PAY LOANS':
    'Customer loan payment (verify name). / Pago de préstamo del cliente (verificar nombre).',
  'EMPLOYEE SHORT PAYMENT':
    'Employee shortage payment. / Pago del corto de empleado.',
  FOOD: 'Food payment. / Pago de comida.',
  'EXTRA MATCH / LUCKY':
    'Courtesy bonus to customer. / Bono de cortesía al cliente.',
  REFERRALS: 'Pay to customer for referral. / Pago al cliente por referido.',
  'SAM’S': 'Sam’s purchase. / Compra en Sam’s.',
  'EMPLOYEE CASH LEFT':
    'Cash received from employee after shift close. / Dinero recibido del empleado al cerrar turno.',
  EXPENSE: 'Any expense not listed. / Cualquier gasto no listado.',
};

export const CLOSING_SHIFT_OPTION = {
  userId: null,
  isClosingShift: true,
  firstname: 'Closing',
  lastname: 'Shift',
};
